import { useAppT } from '../localization/config'
import Email from './Email'
import PhoneNumber from './PhoneNumber'

export default function Footer() {
  const t = useAppT()

  return (
    <footer className="bg-primary p-8">
      <div className="m-auto max-w-2xl">
        <div className="[&_a]:text-light [&_p]:text-light">
          <h2 className="text-light m-0">{t.contact_title}</h2>
          <div className="h-5" />
          <p>{t.name}</p>
          <div className="h-3" />
          <PhoneNumber shorten />
          <div className="h-3" />
          <Email shorten />
          <div className="h-8" />
        </div>
      </div>
    </footer>
  )
}
